var MobileMenu = {

	init: function() {
		MobileMenu.node = $("<div id='mobmenu'><div class='r'></div><div class='b'></div></div>");
		MobileMenu.node.append("<div class='mobmain'><div class='l'></div><div class='m'></div><div class='r'></div></div>");
		$("#overlay").append(MobileMenu.node);
	},

	open: function() {

	}
}